async function fiveNineLogin (username, password) {
  var response = await metaData().then(response => {
    return response
  })

  return response
}

async function metaData () {
  return fetch('https://app.five9.com/appsvcs/rs/svc/auth/metadata', { credentials: 'include' }).then(result => {
    return result.json().then(parsedResult => {
      return { url: parsedResult.metadata.dataCenters[0].apiUrls[0].host, agentId: parsedResult.userId }
    })
  })
}

export default fiveNineLogin
